import { TextSelection } from "prosemirror-state";
import { insertPoint } from "prosemirror-transform";

import { Extension } from "../extension";

/**
 * Function to check if node is descendant of a button. As we are in the context of the note editor,
 * it searches until reaching a HEADER element (i.e, the note header).
 */
function isInButton(element: Node | null) {
	let node = element,
		parent;

	while ((parent = node?.parentNode) && parent && parent.nodeName !== "HEADER") {
		if (parent.nodeName === "BUTTON") return true;
		node = parent;
	}

	return false;
}

class FocusArea extends Extension {
	target?: HTMLElement;
	get name() {
		return "focusit";
	}
	onMouseDown = (e: MouseEvent) => {
		if (!this.target?.contains(e.target as Node) || this.editorView?.dom.parentNode?.contains(e.target as Node)) return;
		if (this.editorView?.hasFocus() && !isInButton(e.target ? (e.target as Node) : null)) {
			// prevent blur
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
	};
	onClick = (e: MouseEvent) => {
		if (!this.editorView) return;
		if (e.target !== this.target) return;
		if (this.editorView?.hasFocus()) return;
		const { clientY } = e;
		if (clientY > (this.editorView?.dom.getBoundingClientRect().y || 0)) {
			let doc = this.editorView.state.doc;
			const pos = insertPoint(doc, doc.nodeSize - 3, this.editorView.state.schema.nodes["text"]);
			if (!pos) return;
			this.editorView.dispatch(this.editorView.state.tr.setSelection(TextSelection.create(doc, pos)));
			this.editorView.focus();
		} else {
			return;
		}
	};
	init() {
		if (!this.options.getTarget) {
			throw new Error("no target selector specified");
		}
		this.target = this.options.getTarget?.(this.editorView?.dom);
		this.target?.addEventListener("mousedown", this.onMouseDown);
		this.target?.addEventListener("click", this.onClick);
	}
	destroy() {
		this.target?.removeEventListener("mousedown", this.onMouseDown);
		this.target?.removeEventListener("click", this.onClick);
	}
}

export default FocusArea;
